import http from '../_httpHandlers';
import { config } from '../_config';
import { IImportComponents } from '../_types/interfaces';

const uri = config.backendAddress;

const importSecureFile = async (data: FormData): Promise<void> => {
    console.log(data);
    await fetch(uri + "/ImportSecureFile", {
        method: "POST",
        body: data,
    });
};

const checkLicenseLoadStatus = async (): Promise<boolean> => {
    return await http.get(`${uri}/CheckLicenseLoadStatus`);
};

export const ImportService: IImportComponents = {
    importSecureFile,
    checkLicenseLoadStatus
};